import React, { useMemo } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import { VsiSelectLabel } from "../styled/VsiLabeledSelect.styled";
import { useVsiAppContext } from "../stores/VsiApp";
import themeStyles, { vsiTitleTextColor } from "../utils/themeStyles";
import { withErrorBoundary } from "../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../boundaries/GeneralErrorBoundary";

function VsiLabeledSelect(
  {
    options,
    selectRef,
    defaultValue,
    isDisabled,
    isLoading,
    label,
    onBlur,
    maxWidth,
    minWidth,
    onChange,
    isMulti,
    placeholder,
    isCreatable,
    onCreateOption,
    inputValue,
    className,
    onInputChange,
    isClearable,
    onKeyDown,
    components,
    id
  }) {
  const { theme } = useVsiAppContext();
  const customStyles = useMemo(() => ({
    control: (base, { isDisabled }) => ({
      ...base,
      background: isDisabled ? themeStyles[theme].disabledBtnColor : themeStyles[theme].selectorBg,
      color: themeStyles[theme].textColor,
      // match with the menu
      borderRadius: 5,
      boxShadow: theme === "light" ? "0 1px 3px hsl(0deg 0% 53% / 49%)" : "none",
      cursor: "pointer",
      "&:hover": {
        background: themeStyles[theme].selectorBgEnabled
      }
    }),
    input: (base) => ({
      ...base,
      color: themeStyles[theme].textColor
    }),
    singleValue: base => ({
      ...base,
      color: themeStyles[theme].textColor

    }),
    menu: base => ({
      ...base,
      // override border radius to match the box
      borderRadius: 0,
      // kill the gap
      marginTop: 0,
      color: themeStyles[theme].textColor,
      "&:hover": {
        // Overwrittes the different states of border
        background: themeStyles[theme].sideBgColor
      }
    }),
    menuList: base => ({
      ...base,
      // kill the white space on first and last option
      padding: 0,
      color: themeStyles[theme].textColor,
      background: themeStyles[theme].selectorBg
    }),
    option: (base, { isFocused, isDisabled, isSelected, data }) => ({
      ...base,
      color: themeStyles[theme].textColor,
      backgroundColor: isSelected ? themeStyles[theme].selectorBgEnabled : themeStyles[theme].selectorBg,
      ":hover": {
        // Overwrittes the different states of border
        ...base[":hover"],
        color: themeStyles[theme].textColor,
        opacity: .6

      }
    })
  }), [theme]);

  const labelColor = themeStyles[theme].titleTextColor;

  return (
    <div className={className} style={{
      maxWidth: maxWidth || 200,
      minWidth: minWidth || 150
    }}>
      {label && <VsiSelectLabel color={labelColor}>{label}</VsiSelectLabel>}
      {isCreatable ? (
          <CreatableSelect className="basic-single neutral90 me-2"
                           id={id}
                           ref={selectRef}
                           classNamePrefix="select"
                           value={defaultValue}
                           isDisabled={isDisabled}
                           isLoading={isLoading}
                           onInputChange={onInputChange}
                           isClearable={isClearable}
                           onChange={onChange}
                           inputValue={inputValue}
                           onKeyDown={onKeyDown}
                           onBlur={onBlur}
                           onCreateOption={onCreateOption}
                           // isSearchable={true}
                           components={components}
                           name="color"
                           options={options}
                           styles={customStyles}
                           isMulti={isMulti}
                           placeholder={placeholder} />
        )
        : (
          <Select
            id={id}
            ref={selectRef}
            className="basic-single neutral90 me-2"
            classNamePrefix="select"
            value={defaultValue}
            defaultValue={defaultValue}
            isDisabled={isDisabled}
            isLoading={isLoading}
            isClearable={isClearable}
            components={components}
            onChange={onChange}
            isSearchable={true}
            name="color"
            options={options}
            styles={customStyles}
            isMulti={isMulti}
            placeholder={placeholder}
          />
        )}
    </div>
  );
}

export default withErrorBoundary(VsiLabeledSelect, GeneralErrorBoundary);
